import React from 'react';
import * as LucideIcons from 'lucide-react';
import { Home } from 'lucide-react';

export function HeaderNavIcon({ name, className }: { name?: string; className?: string }) {
  if (!name) return null;
  const key = name.trim();
  if (!key) return null;
  const Icon = (LucideIcons as unknown as Record<string, React.ComponentType<{ className?: string }>>)[key];
  if (!Icon) return <Home className={className} aria-hidden />;
  return <Icon className={className} aria-hidden />;
}
